import { render, staticRenderFns } from "./VersionView.vue?vue&type=template&id=7380bbfc&scoped=true"
import script from "./VersionView.vue?vue&type=script&lang=js"
export * from "./VersionView.vue?vue&type=script&lang=js"
import style0 from "./VersionView.vue?vue&type=style&index=0&id=7380bbfc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7380bbfc",
  null
  
)

export default component.exports